import { createUseStyles } from 'react-jss';

const borderColourError = '#D2202F';
const backgroundColourError = '#FBE4E6';
const chevronColourError = '#D2202F';

export const useStyles = createUseStyles(() => ({
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    dropdownContainer: ({ isXS }) => ({
        width: isXS ? '100%' : '50%',
        '& div': {
            '& div:nth-of-type(2)': {
                '& div[role=button]:hover': {
                    border: '1px solid #B0B0B0'
                },
                '& div[role=button]:focus': {
                    border: '1px solid #B0B0B0'
                }
            },
            '& div:nth-of-type(3)': {
                marginBottom: '-2rem',
                '& div:nth-of-type(1)': {
                    '& div': {
                        display: 'none'
                    },
                    '& p': {
                        color: 'white'
                    },

                    '& svg': {
                        display: 'none'
                    },
                    background: '#ef425e',
                    padding: '0.5rem',
                    visibility: 'hidden'
                }
            }
        },
        '& .error': {
            '& div:nth-of-type(2)': {
                '& div[role=button]': {
                    border: `1px solid ${borderColourError}`,
                    '& div': {
                        background: `${backgroundColourError}`
                    }
                },

                '& div': {
                    '& ul': {
                        background: 'white',
                        border: 'none',
                        borderRadius: '0px'
                    },
                    '& span': {
                        '& svg': {
                            color: `${chevronColourError}`
                        }
                    }
                }
            },

            '& div:nth-of-type(3)': {
                '& div:nth-of-type(1)': {
                    '& div': {
                        display: 'none',
                        '& svg': {
                            display: 'none'
                        }
                    },

                    visibility: 'visible'
                }
            }
        },
        '& button': {
            '& div': {
                '& span:first-of-type': {
                    color: '#008284'
                }
            }
        }
    }),
    dropdown: {
        border: '1px solid #B0B0B0'
    },
    dropdownLabel: {
        marginBottom: '0.5rem',
        color: '#008284'
    },
    active: {
        border: '1px solid #0DB14B',
        '& div': {
            '& span:first-of-type': {
                color: '#1C3E94'
            }
        }
    },
    dropdownItem: {
        color: '#1C3E94'
    }
}));
